<template>
  <TsSection>
    <div
      class="w-full flex gap-x-3 lg:gap-x-2 gap-y-6 overflow-auto lg:overflow-hidden hide-scroll-bar"
      :data-testid="props.dataTestid"
    >
      <div
        v-for="item in props.data"
        :key="item.id"
        class="w-full md:w-[calc((100%-(0.75rem*5))/6)] lg:w-[calc((100%-(0.5rem*7))/8)]"
        :data-testid="`item-${item.id}`"
      >
        <div
          class="relative bg-[linear-gradient(180.71deg,_#bce2ff_45.71%,_#065cab_80.14%)] p-[1.4px] rounded-2xl mb-2 overflow-hidden"
        >
          <div class="min-w-[100px] bg-white rounded-2xl overflow-hidden w-full">
            <TsImage
              :src="item.image"
              :alt="item.image_alt"
              class="w-full"
              :data-testid="`image-${item.id}`"
              loading="lazy"
            />

            <TsTypography
              variant="sm"
              align="center"
              append-class="flex items-center justify-center bg-primary absolute bottom-0 left-0 right-0 text-idle-white py-0.5 md:py-1.5"
            >
              <TsImage
                src="/images/offer-icon.gif"
                alt="deal by category offer tag"
                width="24"
                class="inline mr-1"
                :data-testid="`tag-icon-${item.id}`"
                loading="lazy"
              />{{ item.image_tag }}
            </TsTypography>
          </div>
        </div>

        <TsTypography
          variant="sm"
          align="center"
          append-class="mb-0 text-natural-black"
          :data-testid="`title-${item.id}`"
        >
          <div v-html="item.title" />
        </TsTypography>
      </div>
    </div>
  </TsSection>
</template>

<script setup lang="ts">
type Data = {
  id: number;
  landingPageUrl?: string;
  image: string;
  image_alt: string;
  image_tag: string;
  title: string;
};

type Props = {
  data?: Data[];
  dataTestid?: string;
};

const props = withDefaults(defineProps<Props>(), {
  dataTestid: '',
  data: () => [
    {
      id: 1,
      image: '/images/screws.png',
      image_alt: 'Deals on screws category',
      image_tag: 'Deals',
      title: 'Screws & Fasteners',
    },
    {
      id: 2,
      image: '/images/battries.png',
      image_alt: 'Deals on batteries category',
      image_tag: 'Deals',
      title: 'Batteries & Chargers',
    },
    {
      id: 3,
      image: '/images/cordless.png',
      image_alt: 'Deals on cordless tools category',
      image_tag: 'Deals',
      title: 'Cordless Tool',
    },
    {
      id: 4,
      image: '/images/trouser.png',
      image_alt: 'Deals on trousers category',
      image_tag: 'Deals',
      title: 'Work Trousers',
    },
    {
      id: 5,
      image: '/images/grinding.png',
      image_alt: 'Deals on grinding machines category',
      image_tag: 'Deals',
      title: 'Grinding Machines',
    },
    {
      id: 6,
      image: '/images/mowers.png',
      image_alt: 'Deals on lawn mowers category',
      image_tag: 'Deals',
      title: 'Lawn Mowers',
    },
    {
      id: 7,
      image: '/images/hammers.png',
      image_alt: 'Deals on hammers category',
      image_tag: 'Deals',
      title: 'Hammer',
    },
    {
      id: 8,
      image: '/images/showers.png',
      image_alt: 'Deals on showers category',
      image_tag: 'Deals',
      title: 'Taps & Showers',
    },
  ],
});
</script>
